if (!customElements.get('partners-marquee')) {
  const FOCUSABLE_SELECTOR =
    'a[href], area[href], button, input, select, textarea, iframe, [tabindex], [contenteditable]';

  class PartnersMarquee extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.partners__marquee-track');
      this._onSectionLoad = this._onSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      this._buildClone();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
    }

    _onSectionLoad(event) {
      if (event.target?.contains(this)) this._buildClone();
    }

    _buildClone() {
      if (!this._track) return;

      const existingClone = this._track.querySelector(':scope > .partners__marquee-clone');
      if (existingClone) existingClone.remove();

      const realItems = [...this._track.children];
      if (realItems.length === 0) return;

      const clone = document.createElement('div');
      clone.className = 'partners__marquee-clone';
      clone.setAttribute('aria-hidden', 'true');

      realItems.forEach((item) => {
        const copy = item.cloneNode(true);
        this._stripEditorAttributes(copy);
        this._removeFromTabOrder(copy);
        clone.appendChild(copy);
      });

      this._track.appendChild(clone);
      this._track.classList.add('is-animating');
    }

    _stripEditorAttributes(root) {
      [root, ...root.querySelectorAll('*')].forEach((el) => {
        el.removeAttribute('id');
        [...el.attributes].forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify-editor')) el.removeAttribute(attribute.name);
        });
      });
    }

    _removeFromTabOrder(root) {
      [root, ...root.querySelectorAll('*')].forEach((el) => {
        if (el.matches(FOCUSABLE_SELECTOR)) el.setAttribute('tabindex', '-1');
      });
    }
  }

  customElements.define('partners-marquee', PartnersMarquee);
}
